<template>
    <div>
        <highcharts
            :constructor-type="'chart'"
            :options="chartOptions"
            class="shadow"
            :callback="generateCard"
        ></highcharts>
    </div>
</template>

<script>
import { colorsCharts } from './colorsCharts.js'
export default {
    props: {
        value: Number,
        definitions: Object,
        onClick: Function
    },
    async created() {
        this.chartOptions.series[0].data[0] = this.value
        this.chartOptions.series[0].name = this.definitions.curve
        this.chartOptions.credits.enabled = this.definitions.credits

        this.chartOptions.yAxis[0].max = this.definitions.meta * 2

        if (this.definitions.meta == 0) {
            this.chartOptions.yAxis[0].min = -20
            this.chartOptions.yAxis[0].max = 20
        }

        var range = [
            this.definitions.meta > 0 ? 0 : -20,
            this.definitions.meta *
                (1 -
                    (this.definitions.greenPercentage +
                        this.definitions.yellowPercentage) /
                        100),
            this.definitions.meta *
                (1 - this.definitions.greenPercentage / 100),
            this.definitions.meta *
                (1 + this.definitions.greenPercentage / 100),
            this.definitions.meta *
                (1 +
                    (this.definitions.greenPercentage +
                        this.definitions.yellowPercentage) /
                        100),
            this.definitions.meta > 0 ? 100 : 20
        ]

        this.chartOptions.yAxis[0].plotBands = []
        range
            .filter((value, index) => index < 5)
            .forEach((value, index) =>
                this.chartOptions.yAxis[0].plotBands.push({
                    from: range[index],
                    to: range[index + 1],
                    color: colorsCharts.speedometer[index],
                    innerRadius: '100%',
                    outerRadius: '105%'
                })
            )
    },
    methods: {
        generateCard({ container }) {
            try {
                let styleCard = ''
                let titleColor = null
                let textColor = null

                switch (this.definitions.curve) {
                    case 'AA':
                        titleColor = colorsCharts.treeMap.green500
                        textColor = 'var(--green-800)'
                        break
                    case 'A':
                        titleColor = colorsCharts.treeMap.green400
                        textColor = 'var(--green-700)'
                        break
                    case 'B':
                        titleColor = colorsCharts.treeMap.yellow400
                        textColor = 'var(--blue-800)'
                        break
                    case 'C':
                        titleColor = colorsCharts.treeMap.orange400
                        textColor = 'var(--orange-800)'
                        break
                    case 'CC':
                        titleColor = colorsCharts.treeMap.red700
                        textColor = colorsCharts.treeMap.red100
                        break
                    default:
                        break
                }

                styleCard = `
                    width:100%;
                    background:${titleColor};
                    color:${textColor};
                    position:absolute;
                    text-align:center;
                    top:-20px;
                    border-radius:6px 6px 0 0;
                    font-size: 1rem;
                    letter-spacing: 1px;
                    font-weight: 500;
                `

                const beforeDiv = document.createElement('div')
                document
                    .getElementById(container.id)
                    .insertAdjacentHTML(
                        'beforebegin',
                        `<div style="${styleCard}">Curva ${this.definitions.curve}</div>`
                    )
                document.getElementById(container.id).appendChild(beforeDiv)
            } catch (errorMessage) {
                this.$notify({
                    message: errorMessage,
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            }
        }
    },
    data() {
        return {
            meta: 0,
            chartOptions: {
                chart: {
                    type: 'gauge',
                    plotBorderWidth: 0,
                    plotBackgroundImage: null,
                    height: '200',
                    style: { cursor: 'pointer' },

                    events: {
                        click: () => this.onClick(this.definitions.curve)
                    }
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: false
                },
                pane: [
                    {
                        startAngle: -30,
                        endAngle: 30,
                        background: null,
                        center: ['50%', '135%'],
                        size: '205%'
                    }
                ],
                tooltip: {
                    enabled: false
                },

                yAxis: [
                    {
                        min: 0,
                        max: 100,
                        minorTickPosition: 'inside',
                        tickPosition: 'outside',
                        tickPixelInterval: 30,
                        tickWidth: 2,
                        tickLength: 10,
                        labels: {
                            rotation: 'auto',
                            distance: 20
                        },
                        plotBands: [],
                        pane: 0
                    }
                ],

                plotOptions: {
                    gauge: {
                        dataLabels: {
                            enabled: false
                        },
                        dial: {
                            radius: '100%'
                        }
                    }
                },

                series: [
                    {
                        name: '',
                        data: [0],
                        yAxis: 0
                    }
                ],

                exporting: {
                    enabled: false
                }
            }
        }
    },
    watch: {
        value: {
            handler: function(value) {
                this.chartOptions.series = [
                    {
                        name: '',
                        data: [value],
                        yAxis: 0
                    }
                ]

                this.chartOptions.yAxis = [{
                    title: {
                        text: `
                            <span style="font-size:12px; color: #000">
                                ${Number(value).toFixed(2)}%
                             de ${Number(this.definitions.meta).toFixed(2)}%
                            </span>`,
                        y: -130
                    }
                }]
            }
        }
    }
}
</script>
<style scoped>
.shadow {
    margin-top: 0.5rem;
    border-top: 1px solid rgba(163, 163, 163, 0.171);
    border-radius: 100%;
}

.titleMeter {
    box-sizing: border-box;
    width: 100%;
    background: red;
    z-index: 9;
    position: absolute;
    text-align: center;
    top: -10px;
}
</style>
